export default __webpack_public_path__ + "static/media/Group 3540.cb304b70.jpg";